export default {
  en: {
    'components.side-nav.main-menu.title': 'Main Menu',
    'components.side-nav.main-menu.dashboard': 'Dashboard',
    'components.side-nav.main-menu.filing': 'Filing',
    'components.side-nav.main-menu.settings': 'Settings',
    'components.side-nav.fineprint.terms': 'Terms & Conditions',
    'components.side-nav.fineprint.privacy-policy': 'Privacy Policy',
    'components.side-nav.version': 'Version',
    'components.side-nav.settings.title': 'Settings',
    'components.side-nav.settings.company-profile': 'Company Profile',
    'components.side-nav.settings.entities': 'Entities',
    'components.side-nav.settings.jurisdictions': 'Jurisdictions',
    'components.side-nav.settings.tax-codes': 'Tax codes',
    'components.side-nav.settings.data-formats': 'Data formats',
    'components.side-nav.settings.users': 'Users',
    'components.side-nav.settings.settings-api': 'API',
    'components.side-nav.settings.account-settings': 'Account Settings',
    'components.side-nav.settings.special-considerations': 'Special Considerations',
    'components.side-nav.jurisdictions.title': 'Jurisdictions',
    'components.side-nav.jurisdictions.registrations': 'Registrations',
    'components.side-nav.jurisdictions.conversion-mappings': 'Conversion Mappings',
  },
};
